/*!
  Pioneer WFRIA Button v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["Button"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("Button") < 0) {
    window.__PIONEER_GLOBAL__.components.push("Button");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from "prop-types";
import React from "react";
import { validIcon } from "../common/proptypes";
import BaseButton from "../private/BaseButton/BaseButton";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let otherProps = Object.assign({}, _ref);
  return _jsx(BaseButton, _objectSpread({
    elementType: "button",
    ref: ref
  }, otherProps));
});
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Set the button active/pressed state. */
  active: PropTypes.bool,

  /** Stretch the button to take the full width of its container up to 300px. */
  block: PropTypes.bool,

  /**
   * An SVGIcon component to create an icon-only-button. When used,
   * children are ignored. For accessibility reasons, you need
   * to also provide an aria-label.
   */
  centerIcon: validIcon,

  /** The body of the button. */
  children: PropTypes.node,

  /** Span 100% width of the parent at all breakpoints. */
  fullWidth: PropTypes.bool,

  /** The style of button. */
  kind: PropTypes.oneOf(["primary", "standard", "chromeless", "simple"]),

  /** An SVGIcon component to place on the left of the button. */
  leftIcon: validIcon,
  radius: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(["small", "medium", "large"])]),

  /**
   * Span 100% width of the parent at lower breakpoint when used without an icon.
   * When combined with an icon, the button does not extend, but the label gets
   * hidden at lower breakpoints.
   */
  responsive: PropTypes.bool,

  /** An SVGIcon component to place on the right of the button. */
  rightIcon: validIcon,
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** Smaller profile. Does not apply to "simple". */
  slim: PropTypes.bool,

  /**
   * Custom spacing for the component. See the
   * "Customization -> Spacing" section.
   */
  spacing: PropTypes.oneOfType([PropTypes.number, PropTypes.shape()]),

  /** The HTML type of the button. */
  type: PropTypes.oneOf(["button", "submit", "reset"])
} : {};
Button.defaultProps = {
  active: null,
  centerIcon: null,
  children: null,
  block: false,
  kind: "primary",
  leftIcon: null,
  radius: "small",
  responsive: false,
  rightIcon: null,
  slim: false,
  size: "medium",
  spacing: {},
  type: "button",
  fullWidth: false
};
Button.displayName = "Button";
export default Button;